export default {
  "topupList.thead.recordId": "RecordId",
  "topupList.thead.merOrderno": "MerOrderno",
  "ttopupList.head.orderno": "Orderno",
  "topupList.thead.phone": "Phone",
  "topupList.thead.amount": "Amount",
  "topupList.thead.statusDesc": "StatusDesc",
  "topupList.thead.createTime": "CreateTime",
  "topupList.thead.startTime": "StartTime",
  "topupList.thead.expireTime": "ExpireTime",
  "topupList.thead.claimTime": "ClaimTime",
  "topupList.thead.topUpTime": "TopUpTime",
  "topupList.thead.option": "Options",
  "topupList.option.topupDone": "Complete",
};
